import { bool, node, number, string } from "prop-types";
import { useRef, useState } from "react";

import styled from "styled-components";

import { useAnimationFrame } from "framer-motion";

import { scrollbarInvisibleThin, scrollbarLightThin } from "UI/scrollbarStyles";

const SDiv = styled("div")`
  max-height: ${({ $maxHeight }) => $maxHeight};
  overflow: auto;
  ${({ $scrollbar }) =>
    $scrollbar ? scrollbarLightThin : scrollbarInvisibleThin}
  ${({ $scrollbar }) => ($scrollbar ? "" : "scrollbar-width: none;")}
  scrollbar-color: ${({
    theme: {
      palette: { taupe, grey },
    },
  }) => `${taupe} ${grey}`};
`;

const maskImage = ({ $topFadeHeight, $bottomFadeHeight }) => {
  return `mask-image: linear-gradient(
    to bottom,
    transparent 0,
    black ${$topFadeHeight}px,
    black calc(100% - ${$bottomFadeHeight}px),
    transparent 100%
    );`;
};

const FadyThing = styled("div")`
  position: relative;
  ${maskImage}
`;

const FnrScrollNFade = ({
  children,
  maxHeight = "50vh",
  fadeThickness = 20,
  scrollbar,
  ...rest
}) => {
  const ref = useRef(null);
  const [topFadeHeight, setTopFadeHeight] = useState(0);
  const [bottomFadeHeight, setBottomFadeHeight] = useState(0);

  useAnimationFrame(() => {
    if (!ref.current) return;
    const newTopHeight = Math.min(ref.current.scrollTop / 3, fadeThickness);
    if (newTopHeight !== topFadeHeight) setTopFadeHeight(newTopHeight);
    const newBottomHeight = Math.min(
      Math.max(
        ref.current.scrollHeight -
          (ref.current.scrollTop + ref.current.clientHeight),
        0
      ) / 3,
      fadeThickness
    );
    if (newBottomHeight !== bottomFadeHeight)
      setBottomFadeHeight(newBottomHeight);
  });

  return (
    <FadyThing
      $fadeThickness={fadeThickness}
      $topFadeHeight={topFadeHeight}
      $bottomFadeHeight={bottomFadeHeight}
      $scrollbar={scrollbar}
      {...rest}
    >
      <SDiv ref={ref} $maxHeight={maxHeight} $scrollbar={scrollbar}>
        {children}
      </SDiv>
    </FadyThing>
  );
};
FnrScrollNFade.propTypes = {
  children: node,
  maxHeight: string,
  fadeThickness: number,
  scrollbar: bool,
};

export default FnrScrollNFade;
